import { post } from '@ug/utils';

export const rtaLogin = async (data = {}) => await post('/api/market/login/rta-login', data);
